import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { queryParamsKeys } from '../utils/queryParamsKeys';


export const useVideoDetailsFromParams = () => {
	const [searchParams] = useSearchParams();
	const {id: videoIdFromUrl} = useParams();
	const location = useLocation();
	const hasTrcPath = location.pathname.includes("/trc/") || location.pathname.includes("/studio-hub/");
	
	const videoId = searchParams.get(queryParamsKeys.videoId) ?? videoIdFromUrl ?? '';
	const target = searchParams.get(queryParamsKeys.target) ?? '';
	const typeOfContentView = searchParams.get(queryParamsKeys.typeOfContentView) ?? (hasTrcPath ? 'TRC' : '');
	const playlistId = searchParams.get(queryParamsKeys.playlistId) ?? '';
	return { videoId, target, typeOfContentView, playlistId };
};
